import { buildCssClassName } from "@/3514/utils"
import { Chevron } from "@/svgs"

import "./styles.scss"

type Props = {
    active: boolean
    width?: number
    height?: number
    variant?: "brand" | "light" | "accent" | "actual"
}

const ChevronToggle = ({ active, variant = "brand", width, height }: Props) => {
    return (
        <div className={buildCssClassName("chevron-toggle", { active })}>
            <Chevron variant={variant} width={width} height={height} />
        </div>
    )
}

export default ChevronToggle
